import { Link } from "react-router";
import { Square } from "lucide-react";

import { ReferenceField } from "@/components/admin/reference-field";
import { entrySeconds, formatClock } from "../workItems/timeFormat";
import { useTimer } from "../workItems/useTimer";
import { UnsettledTimerButton } from "../workItems/workItemCells";

// Viser brukerens løpende timer i toppbaren (uansett hvor i appen du er), med
// lenke til oppgaven og en stopp-knapp. Er stoppen ikke bekreftet av
// serveren, vises «Uavklart» til den er det.
export const ActiveTimerIndicator = () => {
  const timer = useTimer();
  const { runningEntry, unsettledStop, nowMs } = timer;

  if (unsettledStop) return <UnsettledTimerButton timer={timer} />;
  if (!runningEntry) return null;
  const entry = runningEntry;

  return (
    <div className="flex items-center gap-1 rounded-md bg-primary/10 px-2 py-1 text-xs text-primary">
      <Link
        to={`/work_items/${entry.work_item_id}`}
        className="flex max-w-40 items-center gap-1 hover:underline"
      >
        <span className="font-mono tabular-nums">
          {formatClock(entrySeconds(entry.started_at, null, nowMs))}
        </span>
        <span className="truncate">
          <ReferenceField
            record={entry}
            source="work_item_id"
            reference="work_items"
            link={false}
          />
        </span>
      </Link>
      <button
        type="button"
        onClick={() => void timer.stop()}
        disabled={timer.busy}
        aria-label="Stopp timer"
        className="rounded p-0.5 hover:bg-primary/20"
      >
        <Square className="h-3.5 w-3.5 fill-current" />
      </button>
    </div>
  );
};
